// extracted by mini-css-extract-plugin
export var description = "ListItem-module--description--Cu9DG";
export var image = "ListItem-module--image--Pb5yM";
export var imageContainer = "ListItem-module--imageContainer--IQIo8";
export var texts = "ListItem-module--texts--hTkJ0";
export var title = "ListItem-module--title--m87fS";
export var wrapper = "ListItem-module--wrapper--4OM4e";